import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Row, Col } from 'antd';
import { Picker, List } from 'antd-mobile';
import { withTranslation } from 'react-i18next';
import * as SignalR from '@aspnet/signalr';

const REACT_APP_SIGNALR_URL = `${process.env.REACT_APP_STAYMENU_API_URL}/stayMenuHub`;

@inject(
    'templateStore',
    'translationStore',
    'webSettingStore',
    'loginStore',
    'authStore',
    'amenityStore',
    'cleanRoomStore',
    'conciergeStore',
    'dndStore',
    'fnbStore',
    'lateCheckoutStore',
    'laundryStore',
    'shoppingStore',
    'CmsEventHotelStore',
    'CmsFacilityHotelStore',
    'homeSpecialOfferStore',
    'homeRetailOfferStore',
    'homeSpaOfferStore',
    'CmsLanguageStore',
    'CmsClimateStore',
    'TransactionStore',
    'CmsSidebarStore')
@observer
class HeaderPage extends Component {
    constructor(props) {
        super(props)
        this.state = {
            showSideBar: true
        }
    }

    componentDidMount() {
        this.props.templateStore.getActive();
        this.props.webSettingStore.getData();
        this.props.CmsSidebarStore.getAllByLanguage();
        this.props.CmsLanguageStore.getActives().then(() => {

            setTimeout(() => {
                let languageCode = 'en';

                if (localStorage.getItem('lang')) {
                    const selectedLanguage = localStorage.getItem('lang');

                    const {
                        activeLanguages
                    } = this.props.CmsLanguageStore;

                    var language = activeLanguages.find(fi => fi.code === selectedLanguage);
                    if (language) {
                        languageCode = selectedLanguage;
                    }
                }

                this.props.translationStore.setLanguage(languageCode);
                this.props.translationStore.setCurrentLanguageShort(languageCode);
                this.props.i18n.changeLanguage(languageCode);
                this.setState({ language: [languageCode] });

                this.props.CmsClimateStore.getData();
            }, 100);
        });

        let connection = new SignalR.HubConnectionBuilder().withUrl(REACT_APP_SIGNALR_URL).build();
        connection.start().catch(function (err) { return console.error(err.toString()); });
        connection.on(`SignalR_SyncData`, () => { window.location.reload(true); });
    }

    // FUNCTION

    refreshItemLanguageFunction = () => {
        this.props.templateStore.getActive();
        this.props.webSettingStore.getData();
        this.props.CmsClimateStore.getData();
        this.props.TransactionStore.get();
        this.props.CmsEventHotelStore.getAllByLanguage();
        this.props.CmsFacilityHotelStore.getAllByLanguage();
        this.props.homeSpecialOfferStore.initAvailable();
        this.props.homeRetailOfferStore.initAvailable();
        this.props.homeSpaOfferStore.initAvailable();
    }

    // ON CHANGE

    languageOnChange = (language) => {
        const selectedLanguage = language[0];
        this.props.i18n.changeLanguage(selectedLanguage);
        this.props.translationStore.setLanguage(selectedLanguage);
        this.props.translationStore.setCurrentLanguageShort(selectedLanguage);
        this.refreshItemLanguageFunction();
    }

    sideBarClicked = () => {
        this.setState({
            showSideBar: !this.state.showSideBar
        })
    }

    sideBarAboutHotelClicked = () => {
        this.props.history.push('./about-hotel');
    }

    sideBarCompendiumClicked = (id) => {
        this.props.history.push(`./compendium/${id}`);
    }

    sideBarLogoutClicked = () => {
        // RESET Storage
        this.props.authStore.removeGuestInformationInStorage();

        // RESET Store Value
        this.props.amenityStore.resetData();
        this.props.fnbStore.resetData();
        this.props.laundryStore.resetData();
        this.props.shoppingStore.resetData();
        this.props.TransactionStore.resetData();

        this.props.history.push(`./login`);
    }

    // ON RENDER

    getTitleOnRender = () => {
        let title = localStorage.getItem('title');

        if (title) {
            if (title !== 'null') {
                return title.replace(/^"(.*)"$/, '$1');
            }
        }

        return '';
    }

    render() {
        const { activeTemplate } = this.props.templateStore;
        const { data: webSettting } = this.props.webSettingStore;
        const { activeLanguageOptions } = this.props.CmsLanguageStore;
        const { showSideBar } = this.state
        const lastName = JSON.parse(localStorage.getItem('lastName'));
        const { currentLanguageShort } = this.props.translationStore;
        const title = this.getTitleOnRender();
        const { sidebars } = this.props.CmsSidebarStore;

        return (
            <>
                {
                    activeTemplate
                        ?
                        <>
                            {
                                webSettting
                                    ?
                                    <>
                                        <Row>
                                            <Col
                                                span={24}
                                                className='stm-position-fixed stm-top-0 stm-z-index-100000 stm-max-width-500'
                                                style={{
                                                    fontFamily: activeTemplate.templateSetting.header.fontFamily,
                                                    background: activeTemplate.templateSetting.header.backgroundColor,
                                                    color: activeTemplate.templateSetting.header.color,
                                                    fontSize: activeTemplate.templateSetting.header.fontSize,
                                                    lineHeight: `${activeTemplate.templateSetting.header.fontSize + 2}px`
                                                }}
                                            >
                                                <Row>
                                                    <Col
                                                        span={4}
                                                        className='stm-display-flex stm-align-items-center stm-justify-content-center stm-height-50'
                                                        onClick={this.sideBarClicked}>
                                                        <img
                                                            src={require('../../../assets/image/Icon/Menu.svg')}
                                                            alt='Menu' />
                                                    </Col>
                                                    <Col
                                                        span={16}
                                                        className='stm-display-flex stm-align-items-center stm-justify-content-center stm-height-50 stm-text-align-center'>
                                                        {webSettting.welcomeText} {title} {lastName}
                                                    </Col>
                                                    <Col
                                                        span={4}
                                                        className='stm-display-flex stm-align-items-center stm-justify-content-right stm-height-50'>
                                                        <Row className=''>
                                                            <Col span={24}>
                                                                <Picker
                                                                    data={[activeLanguageOptions]}
                                                                    title='Select Language'
                                                                    cascade={false}
                                                                    value={this.state.language}
                                                                    okText={webSettting.okText}
                                                                    dismissText={webSettting.cancelText}
                                                                    onChange={language => this.languageOnChange(language)}
                                                                    onOk={language => this.setState({ language: language })}
                                                                >
                                                                    <List.Item>
                                                                        <Row className='stm-padding-right-8'>
                                                                            <Col
                                                                                span={24}
                                                                                className='stm-text-align-right'
                                                                                style={{
                                                                                    fontFamily: activeTemplate.templateSetting.header.fontFamily,
                                                                                    color: activeTemplate.templateSetting.header.color,
                                                                                    fontSize: activeTemplate.templateSetting.header.fontSize,
                                                                                    lineHeight: `${activeTemplate.templateSetting.header.fontSize + 2}px`
                                                                                }}>
                                                                                {currentLanguageShort}
                                                                                <img
                                                                                    className='stm-width-16 stm-height-24 stm-margin-left-4'
                                                                                    src={require('../../../assets/image/Icon/Dropdown.svg')}
                                                                                    alt='Dropdown' />
                                                                            </Col>
                                                                        </Row>
                                                                    </List.Item>
                                                                </Picker>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                        <Row
                                            className='stm-position-fixed stm-background-F9F9F9 stm-min-width-200 stm-padding-12-16 stm-z-index-9999 stm-top-50'
                                            hidden={showSideBar}
                                            style={{ minHeight: document.documentElement.clientHeight - 99 }}>
                                            <Col>
                                                {/* <Row>
                                                    <Col
                                                        span={24}
                                                        className='stm-padding-10-5 stm-border-bottom-color-E9ECEF stm-border-bottom-style-solid stm-border-bottom-width-1'
                                                        onClick={this.sideBarAboutHotelClicked}>{webSettting.aboutHotelText}</Col>
                                                </Row> */}
                                                {/* Compendium */}
                                                <>
                                                    {
                                                        sidebars
                                                            ?
                                                            <>
                                                                {
                                                                    sidebars.map(sidebar => {
                                                                        return (
                                                                            <Row>
                                                                                <Col
                                                                                    span={24}
                                                                                    className='stm-padding-10-5 stm-border-bottom-color-E9ECEF stm-border-bottom-style-solid stm-border-bottom-width-1'
                                                                                    onClick={() => this.sideBarCompendiumClicked(sidebar.id)}>{sidebar.title}</Col>
                                                                            </Row>
                                                                        )
                                                                    })
                                                                }
                                                            </>
                                                            :
                                                            null
                                                    }
                                                </>
                                                <Row>
                                                    <Col
                                                        span={24}
                                                        className='stm-padding-10-5 stm-border-bottom-color-E9ECEF stm-border-bottom-style-solid stm-border-bottom-width-1'
                                                        onClick={this.sideBarLogoutClicked}>{webSettting.logoutText}</Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    </>
                                    :
                                    null
                            }
                        </>
                        :
                        null
                }
            </>
        )
    }
}

export default withTranslation()(HeaderPage)